if (!customElements.get('size-fit-guide')) {
  customElements.define('size-fit-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('.size-fit__trigger');
      this.trigger.addEventListener('click', () => {
        this.dialog.showModal();
        document.documentElement.classList.add('size-fit-open');
      });
      this.querySelector('.size-fit__close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        this.releaseScroll();
        if (this.isConnected) this.trigger.focus();
      });
      this.querySelectorAll('[data-unit]').forEach((button) => {
        button.addEventListener('click', () => {
          this.querySelectorAll('[data-unit]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          this.querySelectorAll('[data-measurement]').forEach((cell) => {
            const cm = cell.dataset.measurement;
            // Only convert numeric measurements or ranges, never size codes or prose.
            const numeric = /^\s*\d+(?:[.,]\d+)?(?:\s*[-–—]\s*\d+(?:[.,]\d+)?)?\s*$/;
            cell.textContent = button.dataset.unit === 'in' && numeric.test(cm)
              ? cm.replace(/\d+(?:[.,]\d+)?/g, (value) => String(Math.round(Number(value.replace(',', '.')) / 2.54 * 10) / 10))
              : cm;
          });
        });
      });
    }
    releaseScroll() {
      if (!document.querySelector('.size-fit__dialog[open]')) document.documentElement.classList.remove('size-fit-open');
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.releaseScroll();
    }
  });
}
